var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cv-search',_vm._g(_vm._b({staticClass:"cv-toolbar-search",attrs:{"kind":"toolbar","form-item":false,"value":_vm.value,"small":""},on:{"focus":_vm.onFocus,"blur":_vm.onBlur}},'cv-search',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }